import React, { useEffect, useState } from 'react';
import styles from './resetPassword.module.scss';
import {
  IoMail,
  IoLockClosed,
  IoLockOpen,
  IoEyeOffSharp,
  IoEyeSharp
} from 'react-icons/io5';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { Redirect } from 'react-router';
import { ROUTES } from '../../routing/routes';
import { RootState } from '../../redux';
import CInput from '../../components/input/input';
import CButton from '../../components/button/button';
import {
  useForgotPasswordMutation,
  useLoginMutation,
  useResetPasswordMutation
} from '../../api';
import CSwitch from '../../components/switch/switch';
import { FormatError } from 'pdfjs-dist/types/src/shared/util';
import { checkJwtToken, JwtStatus } from '../../utils/jwt';
import { useHistory, useParams } from 'react-router-dom';

type ResetPasswordRouteParams = {
  token: string;
};
const ResetPassword = () => {
  const [loginError, setLoginError] = useState('');
  const { token } = useParams<ResetPasswordRouteParams>();
  const history = useHistory();
  const [form, setForm] = useState({
    newPassword: '',
    confirmPassword: '',
    confirm1: false,
    confirm2: false,
    confirm3: false,
    confirm4: false,
    confirm5: false
  });

  useEffect(() => {
    const status: JwtStatus = checkJwtToken(token);
    if (status === JwtStatus.INVALID) {
      history.push(ROUTES.LOGIN);
    } else if (status === JwtStatus.EXPIRED) {
      history.push(ROUTES.LOGIN);
    }
  }, [token, history]);

  const [resetPassword, { isSuccess, isLoading, error }] =
    useResetPasswordMutation();
  const dispatch = useAppDispatch();

  const session = useAppSelector((state: RootState) => state.session.auth);

  const updateForm = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    setForm(state => ({ ...state, [name]: value }));
  };

  const updateConfirm = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    const { name } = event.target;
    setForm(state => ({ ...state, [name]: checked }));
  };

  useEffect(() => {
    if (error) {
      setLoginError('A aparut o eroare');
    }
  }, [error, dispatch]);

  useEffect(() => {
    if (isSuccess) {
      history.push(ROUTES.LOGIN);
    }
  }, [isSuccess, dispatch, history]);

  const handleSubmit = (event: React.MouseEvent) => {
    event.preventDefault();
    if (
      form.newPassword !== form.confirmPassword ||
      form.newPassword.length < 8
    ) {
      setLoginError(
        'Parolele trebuie sa coincidă și să aibă minim 8 caractere'
      );
      return;
    }
    if (
      !form.confirm1 ||
      !form.confirm2 ||
      !form.confirm3 ||
      !form.confirm4 ||
      !form.confirm5
    ) {
      setLoginError('Trebuie bifate toate optiunile');
      return;
    }
    const request = {
      newPassword: form.newPassword,
      confirmNewPassword: form.confirmPassword,
      token
    };
    resetPassword(request);
  };

  if (session) {
    return <Redirect to={ROUTES.HOME} />;
  }

  return (
    <div className={styles.container}>
      <form>
        <h1>Resetare parolă</h1>
        {loginError && <h2>{loginError}</h2>}
        <CInput
          label='Parolă nouă'
          type='password'
          id='newPassword'
          placeholder='Introduceti noua parola'
          name='newPassword'
          value={form.newPassword}
          onChange={updateForm}
          required
        />
        <CInput
          label='Repetați parola'
          type='password'
          id='confirmPassword'
          placeholder='Reintroduceti noua parola'
          name='confirmPassword'
          value={form.confirmPassword}
          onChange={updateForm}
          required
        />

        <section>
          <label htmlFor='confirm1' className={styles.confirm}>
            <input
              type='checkbox'
              id='confirm1'
              name='confirm1'
              checked={form.confirm1}
              onChange={e => updateConfirm(e, !form.confirm1)}
            />
            In calitate de reprezentant al utilizatorului declar ca am
            capacitatea de reprezenta utilizatorul;
          </label>
        </section>

        <section>
          <label htmlFor='confirm2' className={styles.confirm}>
            <input
              type='checkbox'
              id='confirm2'
              name='confirm2'
              checked={form.confirm2}
              onChange={e => updateConfirm(e, !form.confirm2)}
            />
            <span>
              Accept in mod expres{' '}
              <a
                href='https://soft.sirar.ro/termeni-si-conditii'
                target='_blank'
                rel='noreferrer'
              >
                Termenii si Conditiile de Utilizare
              </a>{' '}
              ai Software-ului Sirar;
            </span>
          </label>
        </section>

        <section>
          <label htmlFor='confirm3' className={styles.confirm}>
            <input
              type='checkbox'
              id='confirm3'
              name='confirm3'
              checked={form.confirm3}
              onChange={e => updateConfirm(e, !form.confirm3)}
            />
            <span>
              Exprim consimtamantul expres al Utilizatorului pentru a primi
              mesaje de marketing din partea Sirar Solutions SRL, prin orice
              canale, inclusiv prin e-mail.
            </span>
          </label>
        </section>

        <section>
          <label htmlFor='confirm4' className={styles.confirm}>
            <input
              type='checkbox'
              id='confirm4'
              name='confirm4'
              checked={form.confirm4}
              onChange={e => updateConfirm(e, !form.confirm4)}
            />
            <span>
              Consimt expres la prelucrarea datelor personale in conditiile{' '}
              <a href='https://soft.sirar.ro/acord-prelucrare-date'>
                Acordului de prelucrare a datelor personale
              </a>
              , precum si ale{' '}
              <a href='https://soft.sirar.ro/politica-de-cookies'>
                Politicii de cookies
              </a>
              .
            </span>
          </label>
        </section>

        <section>
          <label htmlFor='confirm5' className={styles.confirm}>
            <input
              type='checkbox'
              id='confirm5'
              name='confirm5'
              checked={form.confirm5}
              onChange={e => updateConfirm(e, !form.confirm5)}
            />
            <span>
              {' '}
              Am citit si inteleg{' '}
              <a href='https://soft.sirar.ro/politica-de-confidentialitate'>
                Politica de confidentialitate
              </a>{' '}
              a website-ului.
            </span>
          </label>
        </section>

        <CButton
          label='Resetați parola'
          type='submit'
          onClick={handleSubmit}
          className={styles.loginButton}
        />
      </form>
    </div>
  );
};

export default ResetPassword;
